import {
  GridRequestDto,
  TravelFareResponseDto
} from 'app/services/interfaces/apiInterfaces';
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { IPagination } from "app/services/authentication/connection/interfaces/pagination";

export class SearchTravelFareCommand extends IRequestCommand<
  IGridTravelFareResponse,
  ErrorDetails,
  ISearchTravelFareCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override setParameters(params: ISearchTravelFareCommandParameters) {
    this.urlSections.push('carriers');
    this.urlSections.push('rate');
    this.urlSections.push(`${params.carrierUserId}`);
    this.paramsSections.push(`name=${params.name}`);

    this.composeUrl();
  }
}

export interface ISearchTravelFareCommandParameters
  extends IPagination,
  ICommandParameters {
  carrierUserId: number;
  name: string;
}

export interface IGridTravelFareResponse
  extends TravelFareResponseDto,
  ICommandResponse { }
